import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Card from '@material-ui/core/Card';
import CardActions from '@material-ui/core/CardActions';
import CardContent from '@material-ui/core/CardContent';
import Typography from '@material-ui/core/Typography';

const styles = {
  card: {
    minWidth: 275,
  },
  bullet: {
    display: 'inline-block',
    margin: '0 2px',
    transform: 'scale(0.8)',
  },
  title: {
    fontSize: 14,
  },
  pos: {
    marginBottom: 12,
  },
};

function SimpleCard(props) {
  const { classes } = props;
  const { header, subheader = null, body, footer = null } = props;

  return (
    <Card className={classes.card} style={{minHeight:'200px'}}>
      <CardContent>
        <Typography variant="h5" component="h2">
            {header}
        </Typography>
        <Typography className={classes.pos} color="textSecondary">
          {subheader}
        </Typography>
        <Typography component="p">
          {body}
        </Typography>
      </CardContent>
      <CardActions>
        {footer}
      </CardActions>
    </Card>
  );
}

SimpleCard.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SimpleCard);